import { useEffect, useState } from "react";
import {
  Spinner,
  Button,
  Input,
  Form,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axiosInstance from "../request";
import { URL } from "../api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import getPrivilegeList from "./PrivilegeList";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";

const OverdueList = () => {
  const [overdues, setOverdues] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()
  const [filterType, setFilterType] = useState("customerId");
  const [filterValue, setFilterValue] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const privilegeList = getPrivilegeList();

  // Popup states
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [amount, setAmount] = useState("");
  const [paymentLink, setPaymentLink] = useState("");
  const [payLoading, setPayLoading] = useState(false);

// Pagination states
const [currentPage, setCurrentPage] = useState(1);
const [rowsPerPage] = useState(10);
const [hasNextPage, setHasNextPage] = useState(false); 
const [activeFilters, setActiveFilters] = useState({});


const companyCode = localStorage.getItem("companyCode");
const branchCode = localStorage.getItem("branch_code");


  const fetchOverdues = async (page = 1, filters = {}) => {
  setLoading(true);
  try {
    const params = {
      ...filters,
      page: page - 1,      // ✅ backend zero-based
      size: rowsPerPage,
      companyCode: companyCode || null,
      branchCode: companyCode ? branchCode : null  // ✅ page size
    };

    const response = await axiosInstance.get(URL.OVERDUE_LIST, { params });

    const data = Array.isArray(response.data) ? response.data : [];

    setOverdues(data);
    setCurrentPage(page);

    // 🔑 same logic as collection list
    setHasNextPage(data.length === rowsPerPage);

  } catch (err) {
    console.error("Error fetching overdue list:", err);
    setOverdues([]);
    setHasNextPage(false);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  fetchOverdues(1);
}, []);


  const exportToExcel = () => {
  if (overdues.length === 0) {
    toast.error("No data to export");
    return;
  }

  const exportData = overdues.map(item => ({
    "Customer ID": item.customer_id,
    "Loan ID": item.loan_id,
    "EMI ID": item.id,
    "EMI Date": item.emi_date,
    "EMI Amount (₹)": item.emi_amount,
    "Outstanding Amount (₹)": item.outstanding_amount,
    "Fees Outstanding (₹)": item.fees_outstanding_amount,
    "Status": item.emi_status_value
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Overdue List");

  XLSX.writeFile(workbook, "overdue_list.xlsx");
};


  const handleSearch = (e) => {
    e.preventDefault();
    const filters = {};
    if (filterValue.trim()) filters[filterType] = filterValue.trim();
    // if (fromDate) filters.fromDate = formatDateForAPI(fromDate);
    // if (toDate) filters.toDate = formatDateForAPI(toDate);
    if (fromDate) filters.fromDate = fromDate; // yyyy-MM-dd
if (toDate) filters.toDate = toDate;       // yyyy-MM-dd


setActiveFilters(filters);  
fetchOverdues(1, filters);


  };

  const currentLabel = {
    customerId: "Customer ID",
    loanId: "Loan ID",
  }[filterType];

  const openPaymentPopup = (row) => {
    setSelectedRow(row);
    // Prefill amount as sum of outstanding + fees outstanding
    const outstanding = Number(row.outstanding_amount || 0);
    const feesOutstanding = Number(row.fees_outstanding_amount || 0);
    setAmount(outstanding + feesOutstanding);
    setPaymentLink("");
    setModalOpen(true);
  };

  const handleGenerateLink = async () => {
    if (!amount) {
      toast.error("Enter amount first!", { position: "top-right" });
      return;
    }
    setPayLoading(true);
    try {
      const res = await axiosInstance.get(URL.PAYMENT_LINK, {
        params: {
          customerId: selectedRow.customer_id,
          loanId: selectedRow.loan_id,
          amount,
          callbackUrl: "https://peday.money/",
        },
      });
      const link =
        res.data.short_url || res.data.payment_link || res.data.link || "";
      setPaymentLink(link);
      toast.success("Payment link generated!", { position: "top-right" });
    } catch (error) {
      console.error("Error generating link:", error);
      toast.error("Failed to generate link", { position: "top-right" });
    } finally {
      setPayLoading(false);
    }
  };

  const handleSendLink = async () => {
    if (!amount) {
      toast.error("Enter amount first!", { position: "top-right" });
      return;
    }
    setPayLoading(true);
    try {
      await axiosInstance.get(URL.PAYMENT_LINK, {
        params: {
          customerId: selectedRow.customer_id,
          loanId: selectedRow.loan_id,
          amount,
          callbackUrl: "https://peday.money/",
        },
      });
      toast.success("Payment link sent to customer!", { position: "top-right" });
    } catch (error) {
      console.error("Error sending link:", error);
      toast.error("Failed to send link", { position: "top-right" });
    } finally {
      setPayLoading(false);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(paymentLink);
    toast.info("Copied to clipboard!", { position: "bottom-right" });
  };



  return (
//     <div className="container" style={{ fontSize: "14px" }}>
//       <div className="d-flex justify-content-between align-items-center mb-3">
//   <h3 className="mb-0">Overdue List</h3>
//   <Button color="success" size="sm" onClick={exportToExcel}>
//     Export Excel
//   </Button>
// </div>

    <div className="container" style={{ fontSize: "14px" }}>
<div className="d-flex justify-content-between align-items-center mb-3">
  <h3 className="mb-0">Overdue List</h3>
</div>



      <Form onSubmit={handleSearch} className="mb-3">
        <div className="row g-3">
          <div className="col-md-2">
            <Label className="form-label fw-bold">Filter Type</Label>
            <Input
              type="select"
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              bsSize="sm"
            >
              <option value="customerId">Customer ID</option>
              <option value="loanId">Loan ID</option>
            </Input>
          </div>
          <div className="col-md-3">
            <Label className="form-label fw-bold">{currentLabel}</Label>
            <Input
              type="text"
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
              placeholder={`Enter ${currentLabel}`}
              bsSize="sm"
            />
          </div>
          <div className="col-md-2">
            <Label className="form-label fw-bold">From Date</Label>
            <Input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              bsSize="sm"
            />
          </div>
          <div className="col-md-2">
            <Label className="form-label fw-bold">To Date</Label>
            <Input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              bsSize="sm"
            />
          </div>
          <div className="col-md-2 d-flex align-items-end">
            <Button color="primary" type="submit" size="sm">
              Search
            </Button>
          </div>
        </div>
      </Form>

      {loading ? (
        <div className="d-flex align-items-center mt-3" style={{ gap: 8 }}>
          <Spinner size="sm" /> <span>Loading overdue list...</span>
        </div>
      ) : (
        <>
          <div className="table-responsive" style={{ whiteSpace: "nowrap" }}>
            <table className="table table-bordered table-hover align-middle">
              <thead className="table-dark">
                <tr>
                  <th>S.No.</th>
                  <th>Customer ID</th>
                  <th>Customer Name</th>
                  <th>Loan ID</th>
                  <th>Fintech Name</th>
                  <th>EMI ID</th>
                  <th>EMI Date</th>
                  <th>EMI Amount (₹)</th>
                  <th>Outstanding Amount (₹)</th>
                  <th>Fees Outstanding (₹)</th>
                  <th>Status</th>
                  {privilegeList.overdewActionColumn && <th>Action</th>}
                  <th>Customer View</th>
                </tr>
              </thead>
              <tbody>
                {overdues.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>{item.customer_id || "-"}</td>
                    <td>{item.customer_name || "-"}</td>
                    <td>{item.loan_id || "-"}</td>
                    <td>{item.fintech_name || "-"}</td>
                    <td>{item.id || "-"}</td>
                    <td>{item.emi_date || "-"}</td>
                    <td>₹{item.emi_amount?.toLocaleString() || "0"}</td>
                    <td>₹{item.outstanding_amount?.toLocaleString() || "0"}</td>
                    <td>₹{item.fees_outstanding_amount?.toLocaleString() || "0"}</td>
                    <td>{item.emi_status_value || "-"}</td>
                    {privilegeList.overdewActionColumn && (
                      <td>
                        <Button
                          size="sm"
                          color="info"
                          onClick={() => openPaymentPopup(item)}
                        >
                          Pay
                        </Button>
                      </td>
                    )}
                    <td>
                     <button
                      className="btn btn-sm btn-primary"
                      onClick={() => navigate(`/CustomerView?customer_id=${item.customer_id}`)}
                    >
                      View
                    </button>
                    </td>
                  </tr>
                ))}
                {overdues.length === 0 && (
                  <tr>
                    <td colSpan="10" className="text-center text-muted">
                      No overdue records found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

    <div className="d-flex justify-content-center mt-3">
  <div className="d-flex align-items-center" style={{ gap: "10px" }}>

    <button
      className="btn btn-sm btn-outline-primary"
      onClick={() => fetchOverdues(currentPage - 1, activeFilters)}
      disabled={currentPage === 1}
    >
      Prev
    </button>

    <span className="fw-semibold">Page {currentPage}</span>

    {hasNextPage && <span className="text-muted">...</span>}

    <button
      className="btn btn-sm btn-outline-primary"
      onClick={() => fetchOverdues(currentPage + 1, activeFilters)}
      disabled={!hasNextPage}
    >
      Next
    </button>

  </div>
</div>


        </>
      )}

      {/* Popup Modal */}
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} size="sm">
        <ModalHeader toggle={() => setModalOpen(!modalOpen)}>
          Make Payment
        </ModalHeader>
        <ModalBody>
          {selectedRow && (
            <>
              <p>
                <strong>Customer ID:</strong> {selectedRow.customer_id}
              </p>
              <p>
                <strong>Loan ID:</strong> {selectedRow.loan_id}
              </p>
              <Form>
                <Label className="fw-bold">Amount</Label>
                <Input
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="Enter Amount"
                  bsSize="sm"
                />

                <div className="d-flex justify-content-between mt-3">
                  <Button
                    color="info"
                    size="sm"
                    onClick={handleGenerateLink}
                    disabled={payLoading}
                  >
                    {payLoading ? "Processing..." : "Generate Link"}
                  </Button>
                  <Button
                    color="success"
                    size="sm"
                    onClick={handleSendLink}
                    disabled={payLoading}
                  >
                    {payLoading ? "Processing..." : "Send Link"}
                  </Button>
                </div>

                {paymentLink && (
                  <div className="mt-3 p-2 border rounded bg-light">
                    <p className="mb-1">
                      <strong>Generated Link:</strong>
                    </p>
                    <div className="d-flex justify-content-between align-items-center">
                      <small className="text-break">{paymentLink}</small>
                      <Button
                        color="secondary"
                        size="sm"
                        onClick={handleCopy}
                      >
                        Copy
                      </Button>
                    </div>
                  </div>
                )}
              </Form>
            </>
          )}
        </ModalBody>
      </Modal>

      <ToastContainer />
    </div>
  );
};

export default OverdueList;
